import { OR_STATUS_ON_HOLD } from './actions/management/orSubscription';
import { SettingsTab, ManagementPagePanel } from './types';

const subscriptionStatuses = {
  FAILED_PAYMENT: 'FAILED_PAYMENT',
  PAUSED: 'PAUSED',
  ACTIVE: 'ACTIVE',
};

export function getStatus({ failedPayment, status } = {}) {
  if (failedPayment) {
    return subscriptionStatuses.FAILED_PAYMENT;
  }
  if (status === OR_STATUS_ON_HOLD) {
    return subscriptionStatuses.PAUSED;
  }
  return subscriptionStatuses.ACTIVE;
}

export const pageStatistics = {
  OR_STATUS: 'OR_STATUS',
};

export const pageEvents = {
  HEADER_PAYMENT_METHODS_CLICKED: 'OR Manage your payment button on header clicked',
  HEADER_ACTIVATE_CLICKED: 'OR Activate button on header clicked',
  CHANGE_SLOT_DETAILS_CLICKED: 'OR Change slot details clicked',

  CANCEL_ORDER_CLICKED: 'OR Cancel order clicked',
  CANCEL_ORDER_CONFIRMED: 'OR Cancel order - confirmation',
  CANCEL_ORDER_CLOSE: 'OR Cancel order - close pop up',
  CANCEL_ORDER_ERROR: 'OR Cancel order - error',
  CANCEL_ORDER_TRY_AGAIN: 'OR Cancel order error - try again',
  CANCEL_ORDER_ERROR_CLOSE: 'OR Cancel order error - close pop up',

  VIEW_ORDER_CLICKED: 'OR View order clicked',
  EDIT_ORDER_CLICKED: 'OR Edit order clicked',
  CREATE_ORDER_CLICKED: 'OR Create order now clicked',
  CREATE_ORDER_ERROR: 'OR Create order now error',
  CHOOSE_ALTERNATIVES_CLICKED: 'OR Choose alternatives clicked',
  REBOOK_CLICKED: 'OR Rebook clicked',
  MANAGE_PAYMENTS_CLICKED: 'OR Manage payments clicked',

  SHOW_MY_ORDERS_CLICKED: 'OR My Orders redirect clicked',

  ORDERS_TAB_CLICKED: 'OR Orders tab clicked',
  SETTINGS_TAB_CLICKED: 'OR Settings tab clicked',
  SUGGESTED_ORDER_TAB_CLICKED: 'OR Your Suggested Order tab clicked',

  SETTINGS_HOLIDAY_CLICKED: 'OR Settings Holiday clicked',
  SETTINGS_PAYMENT_CLICKED: 'OR Settings Payment clicked',
  SETTINGS_MEMBERSHIP_CLICKED: 'OR Settings Membership clicked',

  ADD_HOLIDAY: 'OR Add Holiday',
  ADD_HOLIDAY_CONFIRMATION: 'OR Add Holiday - confirmation',
  ADD_HOLIDAY_CANCEL: 'OR Add Holiday - cancel',

  CANCEL_HOLIDAY: 'OR Cancel Holiday',
  CANCEL_HOLIDAY_CONFIRMATION: 'OR Cancel Holiday - confirmation',
  CANCEL_HOLIDAY_CANCEL: 'OR Cancel Holiday - cancel',

  PAYMENT_METHODS_CLICKED: 'OR Management payment methods clicked',

  PAUSE_CLICKED: 'OR Pause clicked',
  PAUSE_CONFIRMATION: 'OR Pause - confirmation',
  PAUSE_CLOSE_POPUP: 'OR Pause - close pop up',
  PAUSE_ERROR: 'OR Pause - error',
  PAUSE_ERROR_TRY_AGAIN: 'OR Pause error - try again',
  PAUSE_ERROR_CLOSE_POPUP: 'OR Pause error - close pop up',

  ACTIVATE_CLICKED: 'OR Activate clicked',

  CANCEL_CLICKED: 'OR Cancel clicked',
  CANCEL_CONFIRMATION: 'OR Cancel - confirmation',
  CANCEL_CLOSE_POPUP: 'OR Cancel - close pop up',
  CANCEL_PUT_ON_HOLD_CLICKED: 'OR Cancel - put on hold clicked',
  CANCEL_ERROR: 'OR Cancel - error',
  CANCEL_ERROR_TRY_AGAIN: 'OR Cancel error - try again',
  CANCEL_ERROR_CLOSE_POPUP: 'OR Cancel error - close pop up',
  CANCEL_PUT_ON_HOLD_ERROR_TRY_AGAIN: 'OR Cancel - put on hold error - try again',

  SUGGESTED_ORDER_SHOW_OPTION_CHANGED: 'OR Show option changed',
  SUGGESTED_ORDER_CHANGE_PRODUCT_FREQUENCY: 'OR change product frequency',
};

export const pageEventFields = {
  ORDER_NUMBER: 'ORDER_NUMBER',
  FREQUENCY: 'FREQUENCY',
  SHOW: 'SHOW',
  SKU: 'SKU',
};

export const settingsTabsToEventsMap = {
  [SettingsTab.HOLIDAYS]: pageEvents.SETTINGS_HOLIDAY_CLICKED,
  [SettingsTab.PAYMENT]: pageEvents.SETTINGS_PAYMENT_CLICKED,
  [SettingsTab.MEMBERSHIP]: pageEvents.SETTINGS_MEMBERSHIP_CLICKED,
};

export const panelTabsToEventsMap = {
  [ManagementPagePanel.ORDERS_PANEL]: pageEvents.ORDERS_TAB_CLICKED,
  [ManagementPagePanel.SETTINGS_PANEL]: pageEvents.SETTINGS_TAB_CLICKED,
  [ManagementPagePanel.SUGGESTED_ORDER_PANEL]: pageEvents.SUGGESTED_ORDER_TAB_CLICKED,
};
